module.exports = __webpack_public_path__ + "media/Video 8b.1fa668ed.mp4";